(() => {
  const initializeCarousels = () => {
    document.querySelectorAll('.trusttap-landing-quebec [data-ugc-track]').forEach((track) => {
      if (track.dataset.ugcReady === 'true') return;

      const carousel = track.closest('.landing-ugc-carousel');
      const section = track.closest('.landing-ugc-section');
      const cards = Array.from(track.querySelectorAll('.landing-ugc-card'));
      const previous = carousel?.querySelector('[data-ugc-prev]');
      const next = carousel?.querySelector('[data-ugc-next]');
      const dots = Array.from(section?.querySelectorAll('[data-ugc-dot]') || []);
      if (!cards.length || !previous || !next) return;

      let index = 0;
      let scrollFrame = 0;
      const isMobile = () => window.matchMedia('(max-width: 760px)').matches;

      const updateState = () => {
        previous.hidden = !isMobile();
        next.hidden = !isMobile();
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      };

      const goTo = (target, smooth = true) => {
        index = (target + cards.length) % cards.length;
        if (isMobile()) {
          const card = cards[index];
          const left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
          track.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
        }
        updateState();
      };

      previous.addEventListener('click', () => goTo(index - 1));
      next.addEventListener('click', () => goTo(index + 1));
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => goTo(dotIndex)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const centre = track.scrollLeft + track.clientWidth / 2;
          index = cards.reduce((best, card, cardIndex) => {
            const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - centre);
            return distance < best.distance ? { index: cardIndex, distance } : best;
          }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
          updateState();
        });
      }, { passive: true });

      track.dataset.ugcReady = 'true';
      updateState();
      window.addEventListener('resize', updateState, { passive: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCarousels);
  else initializeCarousels();
  document.addEventListener('shopify:section:load', initializeCarousels);
})();
